// src/components/PricingSection.jsx

import React, { useState } from 'react';

import {

  Box,

  Typography,

  Container,

  Button,

  Paper,

  Tabs,

  Tab,

  Dialog,

  DialogTitle,

  DialogContent,

  TextField,

  MenuItem,

  alpha,

} from '@mui/material';

import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import LanguageIcon from '@mui/icons-material/Language';

import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';

import PaletteIcon from '@mui/icons-material/Palette';

import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';

import SearchIcon from '@mui/icons-material/Search';

import CampaignIcon from '@mui/icons-material/Campaign';

import { motion } from 'framer-motion';

import { useNavigate } from 'react-router-dom';



const BROWN_THEME_PALETTE = {

  primary: "#3E2723",

  secondary: "#6E5B4D",

  accent: "#A06E50",

  background: "#ffffff",

  surface: "#ffffff",

  textPrimary: "#2C1D11",

  textSecondary: "#6E5B4D",

};



// Full Pricing Database exported properly so PricingPage can use it

export const PRICING_CATEGORIES = [

  {

    id: 'websites',

    label: 'Websites',

    icon: <LanguageIcon sx={{ fontSize: 18 }} />,

    illustrationSvg: (

      <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">

        <path fill="currentColor" d="M47.7,-74.3C61.4,-67.2,71.8,-53.4,79.1,-38.3C86.4,-23.2,90.6,-6.9,88.5,8.2C86.4,23.3,78,37.2,67.7,48.4C57.4,59.7,45.2,68.3,31.4,74.1C17.6,79.9,2.2,82.9,-12.3,80.7C-26.8,78.5,-40.4,71.1,-52.5,61.7C-64.6,52.3,-75.2,40.9,-80.4,27.1C-85.6,13.3,-85.4,-2.9,-81.1,-17.8C-76.8,-32.7,-68.4,-46.3,-56.3,-54.3C-44.2,-62.4,-28.4,-64.9,-13.4,-69.5C1.6,-74.2,34,-81.4,47.7,-74.3Z" transform="translate(100 100)" />

      </svg>

    ),

    items: [

      {

        name: 'Landing Page',

        subtitle: 'For campaigns & single products',

        plans: [

          { tier: 'Basic', price: '₹2,500', features: ['1 Responsive Page', 'Hero & CTA Sections', 'Contact Section', 'Basic Animations', 'SEO Basics'] },

          { tier: 'Pro', price: '₹4,500', features: ['Everything in Basic', 'Custom UI/UX', 'Advanced animations', 'Interactive sections', 'Lead/contact forms', 'Analytics', 'Social integrations', 'Performance optimization'] },

          { tier: 'Premium', price: '₹7,500+', features: ['Fully custom design', 'Advanced interactions', 'CMS integration', 'Advanced animations', 'Conversion optimization', 'Analytics', 'API integrations', 'Custom functionality'] },

          { tier: 'Custom', price: 'Propose Your Budget', features: ['Tailored scope', 'Dedicated engineering', 'Custom integrations', 'Priority delivery'] }

        ]

      },

      {

        name: 'Business Website',

        subtitle: 'For companies & local businesses',

        plans: [

          { tier: 'Basic', price: '₹4,200', features: ['Up to 3 Pages', 'Responsive Design', 'Contact Form', 'Basic SEO & SSL', 'Hosting & Deployment'] },

          { tier: 'Pro', price: '₹10,999', popular: true, features: ['Up to 7 pages', 'Custom UI/UX', 'Advanced SEO', 'CMS', 'Analytics', 'Lead forms', 'Social integration', 'Custom animations', '1-year hosting', '6-month maintenance'] },

          { tier: 'Premium', price: '₹18,999', features: ['Custom pages', 'Advanced CMS', 'Admin dashboard', 'Database', 'Authentication', 'API integrations', 'Payment integration', 'Advanced SEO', '1-year hosting', '12-month maintenance', 'Priority support'] },

          { tier: 'Custom', price: 'Propose Your Budget', features: ['Enterprise architecture', 'Multi-region deployment', 'Custom SLAs'] }

        ]

      },

      {

        name: 'E-commerce',

        subtitle: 'For online stores & products',

        plans: [

          { tier: 'Basic', price: '₹8,500', features: ['Product catalogue', 'Product pages', 'Categories', 'Cart', 'Basic checkout', 'Responsive design', 'Basic admin functionality'] },

          { tier: 'Pro', price: '₹15,999', popular: true, features: ['Everything in Basic', 'Payment gateway', 'User accounts', 'Orders', 'Wishlist', 'Search & filters', 'Coupons', 'Admin dashboard', 'Analytics'] },

          { tier: 'Premium', price: '₹29,999+', features: ['Advanced product management', 'Inventory', 'Multiple payment options', 'Shipping integration', 'Advanced admin dashboard', 'Customer management', 'Coupons & offers', 'Analytics', 'API integrations', 'Automation'] },

          { tier: 'Custom', price: 'Propose Your Budget', features: ['Custom multi-vendor logic', 'ERP integrations', 'High volume setup'] }

        ]

      },

      {

        name: 'Web Application',

        subtitle: 'For custom software & platforms',

        plans: [

          { tier: 'Basic', price: '₹10,000', features: ['Custom Interface', 'Authentication (Auth)', 'Basic Database', 'Admin Dashboard', 'Responsive UI'] },

          { tier: 'Pro', price: '₹24,999', popular: true, features: ['Advanced UI/UX', 'Authentication', 'Database', 'APIs', 'Admin dashboard', 'User management', 'Notifications', 'Analytics'] },

          { tier: 'Premium', price: '₹49,999+', features: ['Full application architecture', 'Advanced backend', 'APIs', 'Real-time features', 'Advanced authentication', 'Payments', 'Admin system', 'Analytics', 'AI integrations', 'Automation', 'Third-party integrations'] },

          { tier: 'Custom', price: 'Propose Your Budget', features: ['Enterprise SaaS setup', 'Custom microservices'] }

        ]

      }

    ]

  },

  {

    id: 'apps',

    label: 'Apps',

    icon: <PhoneIphoneIcon sx={{ fontSize: 18 }} />,

    illustrationSvg: (

      <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">

        <path fill="currentColor" d="M37.5,-64.1C50.6,-57.4,64.7,-50.2,71.7,-38.3C78.8,-26.4,78.8,-9.8,75.4,5.3C72,20.4,65.2,34.1,55.3,44.7C45.3,55.4,32.3,62.9,18.3,68.4C4.3,73.9,-10.8,77.3,-24.8,73.6C-38.8,69.8,-51.7,58.8,-61.2,45.8C-70.6,32.7,-76.6,17.6,-77.8,1.9C-79,-13.7,-75.3,-29.9,-65.4,-41.7C-55.5,-53.4,-39.4,-60.7,-24.9,-66.6C-10.4,-72.5,2.5,-77,16.2,-76.3C29.9,-75.7,44.4,-79.8,37.5,-64.1Z" transform="translate(100 100)" />

      </svg>

    ),

    items: [

      {

        name: 'Mobile App',

        subtitle: 'Cross-platform iOS & Android mobile applications.',

        plans: [

          { tier: 'Basic', price: '₹12,000', features: ['Cross-platform setup', 'Up to 5 screens', 'Local state management', 'Basic UI styling', 'API connection'] },

          { tier: 'Pro', price: '₹28,000', popular: true, features: ['Everything in Basic', 'Advanced navigation', 'Push notifications', 'User auth', 'Local database', 'App store packaging'] },

          { tier: 'Premium', price: '₹55,000+', features: ['Full backend sync', 'Real-time sockets', 'Payment processing', 'Advanced animations', 'Offline data sync', 'CI/CD pipeline'] },

          { tier: 'Custom', price: 'Propose Your Budget', features: ['Native modules', 'Complex Bluetooth / GPS features'] }

        ]

      },

      {

        name: 'PWA',

        subtitle: 'Progressive Web Apps built for lightning-fast experiences.',

        plans: [

          { tier: 'Basic', price: '₹6,000', features: ['Manifest setup', 'Service workers', 'Offline fallback page', 'Responsive layout'] },

          { tier: 'Pro', price: '₹14,000', popular: true, features: ['Full offline caching', 'Install prompt UI', 'Push notifications', 'Background sync'] },

          { tier: 'Premium', price: '₹26,000', features: ['Advanced storage caching', 'Native-like performance tweaks', 'Analytics tracking', 'Deep linking'] },

          { tier: 'Custom', price: 'Propose Your Budget', features: ['Enterprise PWA workflow'] }

        ]

      },

      {

        name: 'Dashboard',

        subtitle: 'Administrative control panels and data hubs.',

        plans: [

          { tier: 'Basic', price: '₹7,000', features: ['Metrics summary cards', 'Basic charts', 'User table list', 'Responsive wrapper'] },

          { tier: 'Pro', price: '₹16,000', popular: true, features: ['Advanced filtering & sorting', 'Export to CSV/PDF', 'Role-based access', 'Interactive analytics charts', 'Activity logs'] },

          { tier: 'Premium', price: '₹32,000', features: ['Real-time streaming metrics', 'Custom widgets builder', 'Multi-tenant support', 'Advanced RBAC', 'Webhook alerts'] },

          { tier: 'Custom', price: 'Propose Your Budget', features: ['Custom data lake connection'] }

        ]

      }

    ]

  },

  {

    id: 'brand',

    label: 'Brand & Design',

    icon: <PaletteIcon sx={{ fontSize: 18 }} />,

    illustrationSvg: (

      <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">

        <path fill="currentColor" d="M41.5,-67.2C54.4,-59.6,66.1,-49.4,73.4,-36.2C80.8,-23,83.9,-6.9,81.1,7.7C78.4,22.2,69.8,35.3,59.3,45.7C48.7,56.1,36.2,63.9,22.1,70.2C8,76.5,-7.7,81.3,-22.1,78C-36.5,74.7,-49.6,63.4,-59.5,50.7C-69.4,37.9,-76,23.8,-78.5,8.7C-81.1,-6.3,-79.6,-22.3,-71.4,-34.7C-63.1,-47.1,-48.1,-55.9,-34.5,-63.1C-20.9,-70.3,-8.8,-75.9,4.2,-81.4C17.1,-86.8,28.6,-92.1,41.5,-67.2Z" transform="translate(100 100)" />

      </svg>

    ),

    items: [

      {

        name: 'Logo Design',

        subtitle: 'Memorable, unique logotype & brand marks.',

        plans: [

          { tier: 'Basic', price: '₹1,500', features: ['2 concepts', 'Vector source files', 'High-res PNG/JPG', 'Basic color palette'] },

          { tier: 'Pro', price: '₹3,500', popular: true, features: ['4 concepts', 'Brand guidelines sheet', 'Social media avatars', 'Full vector asset pack', 'Source files'] },

          { tier: 'Premium', price: '₹7,000', features: ['Unlimited concepts', 'Comprehensive brand book', 'Motion logo intro', 'Stationery kit mockup'] },

          { tier: 'Custom', price: 'Propose Your Budget', features: ['Global trademark alignment'] }

        ]

      },

      {

        name: 'Brand Identity',

        subtitle: 'Complete visual systems for emerging brands.',

        plans: [

          { tier: 'Basic', price: '₹5,000', features: ['Logo suite', 'Typography guidelines', 'Color palette', 'Business card template'] },

          { tier: 'Pro', price: '₹12,000', popular: true, features: ['Full brand identity guide', 'Social media kit', 'Letterheads & invoices', 'Presentation template', 'Iconography set'] },

          { tier: 'Premium', price: '₹24,000', features: ['Comprehensive visual system', 'Packaging design', 'Merchandise assets', 'Digital UI styling guide', 'Priority revisions'] },

          { tier: 'Custom', price: 'Propose Your Budget', features: ['Enterprise rebranding campaign'] }

        ]

      }

    ]

  },

  {

    id: 'digital',

    label: 'Digital',

    icon: <RestaurantMenuIcon sx={{ fontSize: 18 }} />,

    illustrationSvg: (

      <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">

        <path fill="currentColor" d="M39,-63.3C52.6,-57.1,67.3,-50.2,74.7,-38.3C82.1,-26.4,82.2,-9.5,79.5,6.1C76.8,21.8,71.4,36.1,62,47.4C52.7,58.7,39.5,67,24.8,72.4C10.2,77.8,-6,80.3,-21.2,77.1C-36.4,74,-50.6,65.2,-61.2,53.2C-71.8,41.1,-78.9,25.8,-80.7,10C-82.5,-5.8,-79.1,-22.1,-70.6,-35.1C-62.1,-48.1,-48.4,-57.8,-34.5,-63.6C-20.6,-69.5,-6.6,-71.4,5.2,-78.9C17,-86.3,25.4,-99.3,39,-63.3Z" transform="translate(100 100)" />

      </svg>

    ),

    items: [

      {

        name: 'Menu Design',

        subtitle: 'Stunning restaurant & cafe digital/print menus.',

        plans: [

          { tier: 'Basic', price: '₹1,200', features: ['Single-page layout', 'High-res print-ready PDF', 'Digital image file'] },

          { tier: 'Pro', price: '₹2,800', popular: true, features: ['Multi-page booklet layout', 'Custom typography styling', 'Food item illustrations', 'QR code integration'] },

          { tier: 'Premium', price: '₹5,500', features: ['Interactive digital menu website link', 'Editable Figma source', 'Multi-variant design', 'Seasonal updates included'] },

          { tier: 'Custom', price: 'Propose Your Budget', features: ['Multi-branch chain menu suite'] }

        ]

      },

      {

        name: 'Digital Business Card',

        subtitle: 'Modern NFC & link-in-bio professional cards.',

        plans: [

          { tier: 'Basic', price: '₹1,000', features: ['Single landing card', 'Direct contact download (vCard)', 'Social links'] },

          { tier: 'Pro', price: '₹2,500', popular: true, features: ['Interactive UI design', 'Lead capture form', 'Custom branding', 'Analytics views'] },

          { tier: 'Business', price: '₹5,000', features: ['Team management panel', 'NFC card writing guide', 'Custom domain support', 'Priority support'] },

          { tier: 'Custom', price: 'Propose Your Budget', features: ['Corporate wide rollout'] }

        ]

      }

    ]

  },

  {

    id: 'seo',

    label: 'SEO',

    icon: <SearchIcon sx={{ fontSize: 18 }} />,

    illustrationSvg: (

      <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">

        <path fill="currentColor" d="M42.4,-69.5C54.8,-60.9,64.4,-48.3,71.7,-34.3C79,-20.3,84.1,-4.9,81.6,9.5C79.1,23.9,69,37.3,57.5,47.8C46,58.3,33.1,65.9,19,72C4.9,78.1,-10.3,82.7,-24.5,79.5C-38.8,76.3,-52.1,65.3,-62.4,52.2C-72.7,39.2,-80.1,24.1,-82.5,8C-84.9,-8.1,-82.3,-25.2,-73.4,-38.7C-64.6,-52.2,-49.4,-62.1,-35.1,-70.2C-20.7,-78.3,-7.4,-84.6,6.3,-83.4C20,-82.2,30,-78.1,42.4,-69.5Z" transform="translate(100 100)" />

      </svg>

    ),

    items: [

      {

        name: 'SEO Setup',

        subtitle: 'Foundational search engine optimization for new sites.',

        plans: [

          { tier: 'Basic', price: '₹2,500', features: ['Meta tags setup', 'Sitemap generation', 'Google Search Console connection', 'Basic keyword check'] },

          { tier: 'Pro', price: '₹5,999', popular: true, features: ['Comprehensive keyword research', 'On-page optimization', 'Robots.txt configuration', 'Google Analytics integration', 'Local business schema'] },

          { tier: 'Premium', price: '₹11,999', features: ['Full site SEO audit', 'Competitor analysis', 'Content gap strategy', 'Advanced schema markup', 'Performance optimization'] },

          { tier: 'Custom', price: 'Propose Your Budget', features: ['Enterprise multi-domain setup'] }

        ]

      }

    ]

  },

  {

    id: 'marketing',

    label: 'Marketing',

    icon: <CampaignIcon sx={{ fontSize: 18 }} />,

    illustrationSvg: (

      <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">

        <path fill="currentColor" d="M38,-65.4C50.2,-57.4,61.9,-48.1,70.5,-36.3C79.1,-24.5,84.6,-10.2,83.9,4C83.3,18.3,76.5,32.4,66.8,43.3C57.2,54.2,44.7,61.9,31.2,68.5C17.7,75.1,3.3,80.6,-11.2,79.8C-25.7,79,-40.3,71.9,-51.7,60.8C-63.1,49.8,-71.3,34.8,-75.4,18.9C-79.6,3,-79.8,-13.8,-73.4,-27.6C-67,-41.4,-54,-52.3,-41,-60.2C-28,-68.2,-14,-73.2,0.5,-73.9C15,-74.6,30,-73.4,38,-65.4Z" transform="translate(100 100)" />

      </svg>

    ),

    items: [

      {

        name: 'Social Media',

        subtitle: 'Engaging content strategy & post creatives.',

        plans: [

          { tier: 'Basic', price: '₹3,500/mo', features: ['8 Custom post graphics per month', 'Basic caption writing', 'Hashtag strategy'] },

          { tier: 'Pro', price: '₹8,000/mo', popular: true, features: ['16 Custom post graphics', 'Reels/Shorts editing (4/mo)', 'Content calendar', 'Scheduled posting support'] },

          { tier: 'Premium', price: '₹16,000/mo', features: ['Daily content creation & posting', 'Full community management', 'Paid ad campaign setups', 'Monthly analytics report'] },

          { tier: 'Custom', price: 'Propose Your Budget', features: ['Omnichannel brand takeover'] }

        ]

      }

    ]

  }

];



const WHATSAPP_NUMBER = "7689919139";

const handleWhatsAppPackage = (service, plan, category) => {
  const message = [
    "Hi WiYou! Tech Studios 👋",
    "",
    "I'm interested in starting with this package:",
    "",
    `Category: ${category}`,
    `Package: ${service.name}`,
    `Plan: ${plan.tier}`,
    `Price: ${plan.price}`,
    "",
    "Package includes:",
    ...plan.features.map((feature) => `• ${feature}`),
    "",
    "I'd like to discuss the next steps.",
  ].join("\n");

  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
  window.open(whatsappUrl, "_blank", "noopener,noreferrer");
};

const PricingSection = () => {

  const [selectedTab, setSelectedTab] = useState(0);

  const [modalOpen, setModalOpen] = useState(false);

  const [selectedService, setSelectedService] = useState('');

  const [selectedBidCategory, setSelectedBidCategory] = useState('');

  const [clientBudget, setClientBudget] = useState('');

  const [clientName, setClientName] = useState('');

  const [clientEmail, setClientEmail] = useState('');

  const [projectRequirements, setProjectRequirements] = useState('');

  const [projectTimeline, setProjectTimeline] = useState('');

  const [additionalNotes, setAdditionalNotes] = useState('');

  const navigate = useNavigate();



  const handleOpenModal = () => {
    setSelectedBidCategory(currentCategory.label);
    setSelectedService('');
    setClientBudget('');
    setClientName('');
    setClientEmail('');
    setProjectRequirements('');
    setProjectTimeline('');
    setAdditionalNotes('');
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedService('');
    setClientBudget('');
    setClientName('');
    setClientEmail('');
    setProjectRequirements('');
    setProjectTimeline('');
    setAdditionalNotes('');
  };

  const handleSubmitProposal = (e) => {
    e.preventDefault();

    const message = [
      'Hi WiYou! Tech Studios 👋',
      '',
      "I'd like to propose a custom bid for a project.",
      '',
      `Category: ${selectedBidCategory}`,
      `Service: ${selectedService}`,
      `Name: ${clientName}`,
      `Email: ${clientEmail}`,
      `Proposed Budget: ${clientBudget}`,
      projectTimeline ? `Timeline: ${projectTimeline}` : '',
      '',
      'Project Requirements:',
      projectRequirements,
      additionalNotes ? '' : null,
      additionalNotes ? 'Additional Notes:' : '',
      additionalNotes || '',
      '',
      "I'd like to discuss the project and see if we can work within this budget.",
    ].filter((line) => line !== null).join('\n');

    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    handleCloseModal();
  };

  const currentCategory = PRICING_CATEGORIES[selectedTab];



    return (
    <Box
      component="section"
      id="pricing-section"
      sx={{
        position: "relative",
        py: { xs: 8, md: 13 },
        px: { xs: 2, md: 4 },
        backgroundColor: 'transparent',
        color: BROWN_THEME_PALETTE.textPrimary,
        overflow: "hidden",
      }}
    >
      <Container maxWidth="xl">
        {/* Editorial hero */}
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.65 }}
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1.1fr .9fr" },
            gap: { xs: 3, md: 8 },
            alignItems: "end",
            mb: { xs: 5, md: 7 },
          }}
        >
          <Box>

            <Typography
              component="h2"
              sx={{
                fontSize: { xs: "2.7rem", sm: "3.7rem", md: "5.4rem" },
                lineHeight: ".9",
                letterSpacing: "-.065em",
                fontWeight: 750,
                color: BROWN_THEME_PALETTE.primary,
              }}
            >
              Build what
              <br />
              <Box component="span" sx={{ color: BROWN_THEME_PALETTE.accent }}>
                matters.
              </Box>
            </Typography>
          </Box>

          <Box sx={{ maxWidth: 510, ml: { md: "auto" }, pb: { md: 1 } }}>
            <Typography sx={{ fontSize: { xs: ".95rem", md: "1.03rem" }, lineHeight: 1.75, color: BROWN_THEME_PALETTE.secondary }}>
              Clear packages for websites, apps, design, digital products, SEO and marketing — with enough flexibility to shape the scope around your actual needs.
            </Typography>
          </Box>
        </Box>

        {/* Category rail */}
        <Box 
          sx={{ 
            mb: { xs: 5, md: 7 }, 
            width: '100%',
            overflow: 'hidden', 
          }}
        >
          <Tabs
            value={selectedTab}
            onChange={(_, value) => setSelectedTab(value)}
            variant="standard"
            centered
            sx={{
              minHeight: 0,
              "& .MuiTabs-flexContainer": { 
                gap: 1, 
                flexWrap: 'wrap', 
                justifyContent: 'flex-start' 
              },
              "& .MuiTabs-indicator": { height: 0 },
              "& .MuiTab-root": {
                minHeight: { xs: 44, md: 44 },
                minWidth: 'auto',
                px: { xs: 2, md: 2.6 },
                borderRadius: "50px",
                my: 0.5,
                color: BROWN_THEME_PALETTE.secondary,
                background: 'rgba(255, 253, 250, 0.94)',
                border: '1px solid rgba(43, 33, 28, 0.06)',
                backdropFilter: "blur(10px)",
                textTransform: "none",
                fontSize: ".78rem",
                fontWeight: 700,
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                "&:hover": { 
                  color: BROWN_THEME_PALETTE.primary, 
                  backgroundColor: alpha(BROWN_THEME_PALETTE.accent, .08),
                  borderColor: alpha(BROWN_THEME_PALETTE.accent, .2),
                  transform: "translateY(-1px)",
                },
                "&.Mui-selected": { 
                  color: '#FFFDF9', 
                  background: alpha(BROWN_THEME_PALETTE.accent, .95), 
                  borderColor: 'transparent',
                },
              },
            }}
          >
            {PRICING_CATEGORIES.map((cat, index) => (
              <Tab
                key={cat.id}
                icon={cat.icon}
                iconPosition="start"
                label={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.2 }}>
                    <Typography 
                      component="span" 
                      sx={{ 
                        fontSize: ".6rem", 
                        fontWeight: 800, 
                        color: selectedTab === index ? '#EAB463' : BROWN_THEME_PALETTE.accent,
                        transition: "color 0.3s ease",
                      }}
                    >
                      {String(index + 1).padStart(2, "0")}
                    </Typography>
                    {cat.label}
                  </Box>
                }
              />
            ))}
          </Tabs>
        </Box>

        {/* Selected category intro */}
        <Box
          component={motion.div}
          key={currentCategory.id}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: .4 }}
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "auto 1fr auto" },
            alignItems: "end",
            gap: { xs: 2, md: 4 },
            mb: 3,
          }}
        >
          <Typography sx={{ fontSize: { xs: "4rem", md: "6rem" }, lineHeight: ".7", letterSpacing: "-.08em", fontWeight: 700, color: alpha(BROWN_THEME_PALETTE.accent, .18) }}>
            {String(selectedTab + 1).padStart(2, "0")}
          </Typography>

          <Box>
            <Typography sx={{ fontSize: { xs: "1.8rem", md: "2.5rem" }, lineHeight: 1, letterSpacing: "-.05em", fontWeight: 750, color: BROWN_THEME_PALETTE.primary }}>
              {currentCategory.label}
            </Typography>
            <Typography sx={{ mt: 1, fontSize: ".86rem", lineHeight: 1.6, color: BROWN_THEME_PALETTE.secondary, maxWidth: 600 }}>
              {currentCategory.items.length} focused {currentCategory.items.length === 1 ? "solution" : "solutions"} with clear starting points and flexible scope.
            </Typography>
          </Box>

          <Typography sx={{ fontSize: ".64rem", fontWeight: 800, letterSpacing: ".1em", textTransform: "uppercase", color: BROWN_THEME_PALETTE.secondary, pb: .5 }}>
            Starting from {currentCategory.items[0]?.plans?.[0]?.price || "Custom"}
          </Typography>
        </Box>

        {/* Pricing cards */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0,1fr))", lg: `repeat(${Math.min(currentCategory.items.length, 4)}, minmax(0,1fr))` },
            gap: { xs: 1.5, md: 2 },
          }}
        >
          {currentCategory.items.map((service, index) => {
            const starterPlan = service.plans[0];
            const isPopular = starterPlan.popular || false;

            return (
              <Box
                key={`${currentCategory.id}-${service.name}`}
                component={motion.div}
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: .45, delay: index * .06 }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    position: "relative",
                    height: "100%",
                    minHeight: { xs: 405, md: 455 },
                    p: { xs: 2.5, md: 3 },
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "18px",
                    overflow: "hidden",
                    backgroundColor: isPopular ? BROWN_THEME_PALETTE.primary : 'rgba(255, 253, 250, 0.94)',
                    color: isPopular ? "#FFFDF9" : BROWN_THEME_PALETTE.primary,
                    border: `1px solid ${isPopular ? BROWN_THEME_PALETTE.primary : alpha(BROWN_THEME_PALETTE.primary, .14)}`,
                    transition: "transform .35s cubic-bezier(.22,1,.36,1), box-shadow .35s ease, border-color .25s ease",
                    "&:hover": {
                      transform: "translateY(-7px)",
                      boxShadow: isPopular ? "0 22px 50px rgba(62,39,35,.18)" : "0 20px 45px rgba(62,39,35,.09)",
                      borderColor: isPopular ? BROWN_THEME_PALETTE.primary : alpha(BROWN_THEME_PALETTE.accent, .42),
                    },
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2, pb: 2.3, borderBottom: `1px solid ${isPopular ? "rgba(255,255,255,.16)" : alpha(BROWN_THEME_PALETTE.primary,.11)}` }}>
                    <Box>
                      <Typography sx={{ fontSize: ".6rem", fontWeight: 800, letterSpacing: ".12em", textTransform: "uppercase", color: isPopular ? "rgba(255,255,255,.55)" : BROWN_THEME_PALETTE.accent, mb: 1 }}>
                        {String(index + 1).padStart(2, "0")} / {currentCategory.label}
                      </Typography>
                      <Typography component="h3" sx={{ fontSize: { xs: "1.35rem", md: "1.48rem" }, lineHeight: 1.05, letterSpacing: "-.035em", fontWeight: 750, color: "inherit" }}>
                        {service.name}
                      </Typography>
                    </Box>

                    {isPopular && (
                      <Box sx={{ alignSelf: "flex-start", flexShrink: 0, px: 1, py: .55, borderRadius: "999px", border: "1px solid rgba(255,255,255,.25)", color: "#FFFDF9", fontSize: ".56rem", fontWeight: 800, letterSpacing: ".1em", textTransform: "uppercase" }}>
                        Popular
                      </Box>
                    )}
                  </Box>

                  <Typography sx={{ mt: 2, minHeight: 48, fontSize: ".77rem", lineHeight: 1.55, color: isPopular ? "rgba(255,255,255,.68)" : BROWN_THEME_PALETTE.secondary }}>
                    {service.subtitle}
                  </Typography>

                  <Box sx={{ mt: 2.5, mb: 3 }}>
                    <Typography sx={{ fontSize: ".6rem", fontWeight: 800, letterSpacing: ".1em", textTransform: "uppercase", color: isPopular ? "rgba(255,255,255,.5)" : BROWN_THEME_PALETTE.secondary, mb: .8 }}>
                      Starting from
                    </Typography>
                    <Typography sx={{ fontSize: { xs: "1.65rem", md: "1.85rem" }, lineHeight: 1, letterSpacing: "-.05em", fontWeight: 800, color: isPopular ? "#FFFDF9" : BROWN_THEME_PALETTE.primary }}>
                      {starterPlan.price}
                    </Typography>
                  </Box>

                  <Box component="ul" sx={{ m: 0, p: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: 1.1, flex: 1 }}>
                    {starterPlan.features.slice(0, 6).map((feature, featureIndex) => (
                      <Box component="li" key={`${feature}-${featureIndex}`} sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
                        <CheckCircleRoundedIcon sx={{ fontSize: 15, mt: .15, flexShrink: 0, color: isPopular ? "rgba(255,255,255,.7)" : BROWN_THEME_PALETTE.accent }} />
                        <Typography sx={{ fontSize: ".74rem", lineHeight: 1.4, color: isPopular ? "rgba(255,255,255,.76)" : BROWN_THEME_PALETTE.textSecondary }}>
                          {feature}
                        </Typography>
                      </Box>
                    ))}
                  </Box>

                  <Button
                    fullWidth
                    variant={isPopular ? "contained" : "outlined"}
                    onClick={() =>
  handleWhatsAppPackage(
    service,
    starterPlan,
    currentCategory.label
  )
}
                    endIcon={<ArrowForwardRoundedIcon sx={{ fontSize: "15px !important" }} />}
                    sx={{
                      mt: 3,
                      minHeight: 44,
                      borderRadius: "11px",
                      textTransform: "none",
                      fontSize: ".75rem",
                      fontWeight: 750,
                      boxShadow: "none",
                      backgroundColor: isPopular ? "#FFFDF9" : alpha(BROWN_THEME_PALETTE.accent, .06),
                      color: BROWN_THEME_PALETTE.primary,
                      borderColor: isPopular ? "#FFFDF9" : alpha(BROWN_THEME_PALETTE.primary, .06),
                      "&:hover": {
                        boxShadow: "none",
                        backgroundColor: isPopular ? "#F5F0EA" : alpha(BROWN_THEME_PALETTE.accent, .07),
                        borderColor: BROWN_THEME_PALETTE.accent,
                      },
                    }}
                  >
                    Start this package
                  </Button>
                </Paper>
              </Box>
            );
          })}
        </Box>

        {/* Custom scope */}
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: .2 }}
          transition={{ duration: .5 }}
          sx={{
            mt: { xs: 2, md: 2.5 },
            p: { xs: 2.5, md: 3 },
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr auto" },
            alignItems: "center",
            gap: 3,
            border: `0px solid ${alpha(BROWN_THEME_PALETTE.primary, .15)}`,
            borderRadius: "18px",
            backgroundColor: alpha(BROWN_THEME_PALETTE.accent, .13),
          }}
        >
          <Box>
            <Typography sx={{ fontSize: ".6rem", fontWeight: 800, letterSpacing: ".11em", textTransform: "uppercase", color: BROWN_THEME_PALETTE.accent, mb: .7 }}>
              Different scope?
            </Typography>
            <Typography sx={{ fontSize: { xs: "1.08rem", md: "1.22rem" }, fontWeight: 750, letterSpacing: "-.025em", color: BROWN_THEME_PALETTE.primary }}>
              Tell us what you actually need. We’ll shape the scope around it.
            </Typography>
            <Typography sx={{ mt: .6, fontSize: ".74rem", color: BROWN_THEME_PALETTE.secondary }}>
              Tailored requirements · Flexible milestones · Dedicated support
            </Typography>
          </Box>

          <Button
            variant="contained"
            onClick={handleOpenModal}
            endIcon={<ArrowForwardRoundedIcon />}
            sx={{
              minWidth: { md: 175 },
              minHeight: 46,
              borderRadius: "11px",
              backgroundColor: BROWN_THEME_PALETTE.primary,
              color: "#FFFDF9",
              textTransform: "none",
              fontWeight: 750,
              fontSize: ".75rem",
              boxShadow: "none",
              "&:hover": { backgroundColor: "#2C1D11", boxShadow: "none" },
            }}
          >
            Propose your budget
          </Button>
        </Box>

        {/* Catalog CTA */}
        <Box sx={{ mt: { xs: 5, md: 7 }, pt: 3, borderTop: `1px solid ${alpha(BROWN_THEME_PALETTE.primary,.12)}`, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, flexWrap: "wrap" }}>
          <Typography sx={{ fontSize: ".74rem", color: BROWN_THEME_PALETTE.secondary }}>
            Need the complete breakdown of every plan?
          </Typography>
          <Button
            onClick={() => navigate("/pricing")}
            endIcon={<ArrowForwardRoundedIcon />}
            sx={{
              p: 0,
              minWidth: 0,
              borderRadius: 0,
              color: BROWN_THEME_PALETTE.primary,
              textTransform: "none",
              fontWeight: 800,
              fontSize: ".75rem",
              borderBottom: `1px solid ${BROWN_THEME_PALETTE.primary}`,
              "&:hover": { backgroundColor: "transparent", color: BROWN_THEME_PALETTE.accent, borderColor: BROWN_THEME_PALETTE.accent },
            }}
          >
            Explore complete pricing catalog
          </Button>
        </Box>

        {/* Custom bid dialog */}
        <Dialog
          open={modalOpen}
          onClose={handleCloseModal}
          fullWidth
          maxWidth="sm"
          PaperProps={{
            sx: {
              borderRadius: "22px",
              backgroundColor: "#FFFDF9",
              p: { xs: 2, md: 2.5 },
              border: `1px solid ${alpha(BROWN_THEME_PALETTE.primary, .14)}`,
              boxShadow: "0 28px 70px rgba(43,33,28,.18)",
            },
          }}
        >
          <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 2 }}>
            <Box>
              <DialogTitle sx={{ p: 0, fontSize: "1.3rem", fontWeight: 800, letterSpacing: "-.03em", color: BROWN_THEME_PALETTE.primary }}>
                Propose your bid
              </DialogTitle>
              <Typography sx={{ mt: .6, fontSize: ".76rem", lineHeight: 1.55, color: BROWN_THEME_PALETTE.secondary }}>
                Tell us what you need and your budget. We’ll prepare the WhatsApp message for you.
              </Typography>
            </Box>
            <Button onClick={handleCloseModal} sx={{ minWidth: 38, width: 38, height: 38, p: 0, borderRadius: "50%", color: BROWN_THEME_PALETTE.secondary }}>
              <CloseRoundedIcon fontSize="small" />
            </Button>
          </Box>

          <DialogContent sx={{ p: 0, pt: 2.5 }}>
            <Box component="form" onSubmit={handleSubmitProposal} sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
              <TextField
                label="Category"
                fullWidth
                value={selectedBidCategory}
                InputProps={{ readOnly: true }}
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "11px", backgroundColor: alpha(BROWN_THEME_PALETTE.primary, .025) } }}
              />

              <TextField
                select
                label="Service"
                required
                fullWidth
                value={selectedService}
                onChange={(e) => setSelectedService(e.target.value)}
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "11px" } }}
              >
                <MenuItem value="" disabled>Select a service</MenuItem>
                {currentCategory.items.map((service) => (
                  <MenuItem key={service.name} value={service.name}>
                    {service.name}
                  </MenuItem>
                ))}
              </TextField>

              <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 1.5 }}>
                <TextField label="Your Name" required fullWidth value={clientName} onChange={(e) => setClientName(e.target.value)} size="small" sx={{ "& .MuiOutlinedInput-root": { borderRadius: "11px" } }} />
                <TextField label="Email Address" type="email" required fullWidth value={clientEmail} onChange={(e) => setClientEmail(e.target.value)} size="small" sx={{ "& .MuiOutlinedInput-root": { borderRadius: "11px" } }} />
              </Box>

              <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 1.5 }}>
                <TextField label="Proposed Budget" placeholder="e.g. ₹15,000" required fullWidth value={clientBudget} onChange={(e) => setClientBudget(e.target.value)} size="small" sx={{ "& .MuiOutlinedInput-root": { borderRadius: "11px" } }} />
                <TextField label="Timeline (Optional)" placeholder="e.g. 2–3 weeks" fullWidth value={projectTimeline} onChange={(e) => setProjectTimeline(e.target.value)} size="small" sx={{ "& .MuiOutlinedInput-root": { borderRadius: "11px" } }} />
              </Box>

              <TextField
                label="Project Requirements"
                placeholder="Tell us what you want to build, key features, pages, integrations, etc."
                required
                fullWidth
                multiline
                minRows={4}
                value={projectRequirements}
                onChange={(e) => setProjectRequirements(e.target.value)}
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "11px" } }}
              />

              <TextField
                label="Additional Notes (Optional)"
                placeholder="Anything else we should know?"
                fullWidth
                multiline
                minRows={2}
                value={additionalNotes}
                onChange={(e) => setAdditionalNotes(e.target.value)}
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "11px" } }}
              />

              <Button
                type="submit"
                variant="contained"
                fullWidth
                endIcon={<ArrowForwardRoundedIcon />}
                sx={{ mt: .5, minHeight: 48, borderRadius: "11px", backgroundColor: BROWN_THEME_PALETTE.primary, color: "#FFFDF9", textTransform: "none", fontWeight: 750, boxShadow: "none", "&:hover": { backgroundColor: "#2C1D11", boxShadow: "none" } }}
              >
                Continue to WhatsApp
              </Button>

              <Typography sx={{ textAlign: "center", fontSize: ".68rem", lineHeight: 1.5, color: BROWN_THEME_PALETTE.secondary }}>
                Your details will be added to a pre-filled WhatsApp message for our team.
              </Typography>
            </Box>
          </DialogContent>
        </Dialog>
      </Container>
    </Box>
  );
};

export default PricingSection;
